import { homePageRoutes } from '@neptune/home-page-api';
import { invitationRoutes } from '@neptune/invitations-api';
import { compatibilityRoutes, projectRoutes } from '@neptune/project-shell';

import cancellationSurveyRoutes from './cancellation-survey/routes';
import organizationRoutes from './organization/routes';
import { createWorkspaceRoutes } from './team-trial-flow/routes';
import userProfileRoutes from './user-profile/routes';

export default [
  ...homePageRoutes,
  ...organizationRoutes,
  ...projectRoutes,
  ...compatibilityRoutes,
  ...userProfileRoutes,
  ...invitationRoutes,
  ...cancellationSurveyRoutes,
  ...createWorkspaceRoutes,
];
